import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import {HistoryElement} from '@/models/HistoryElement';
import {FpMessageType} from '@/modules/deals/enums/FpMessageType';
import {isEqual, chain} from 'lodash-es';
import FpMessage from '@/components/messages/FpMessage.vue';
import DateUtils from '@/services/utils/DateUtils';
import {I18NGetter} from '@/services/enumTranslator/I18NGetter';
import {BaseFilter, ProspectHistoryFilter} from '@/models/Filter';
import { useInstance } from '@/composables/useInstance';
interface Props {
  showNewNoteOption?: boolean;
  chat?: boolean;
  notesOnly?: boolean;
  last?: number;
  historyElements: HistoryElement<any>[];
  dealId?: number;
  loanApplicationId?: number;
  isSidebar?: boolean;
  filterOptions?: BaseFilter;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'HistoryElements',
  props: {
    showNewNoteOption: { type: Boolean, default: true },
    chat: { type: Boolean, default: false },
    notesOnly: { type: Boolean, default: false },
    last: { default: 0 },
    historyElements: { default: () => [] },
    dealId: null,
    loanApplicationId: null,
    isSidebar: { type: Boolean, default: false },
    filterOptions: null
  },
  emits: ["click:new-note", "fetchHistoryElements"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'click:new-note', newNote: string, dealId: number | undefined): void,
  (e: 'fetchHistoryElements'): void,
}), expose: any, slots: any, attrs: any }) {

const props = __props as { showNewNoteOption: boolean, chat: boolean, notesOnly: boolean, last: number, historyElements: HistoryElement<any>[], dealId?: number, loanApplicationId?: number, isSidebar: boolean, filterOptions?: BaseFilter }

const {$snackbarService,} = useInstance();





const newNote = ref<string>('');

function findFirst(elements: HistoryElement<any>[], f: (n: string) => boolean): HistoryElement<any> | undefined {
  return elements.find(date => f(date.createdDate));
}

function isToday(historyElement: HistoryElement<any>): boolean {
  return isEqual(historyElement, findFirst(props.historyElements, DateUtils.isToday));
}

function isYesterday(historyElement: HistoryElement<any>): boolean {
  return isEqual(historyElement, findFirst(props.historyElements, DateUtils.isYesterday));
}

function isDayBeforeYesterday(historyElement: HistoryElement<any>): boolean {
  return isEqual(historyElement, findFirst(props.historyElements, DateUtils.isDayBeforeYesterday));
}

function isThisWeek(historyElement: HistoryElement<any>): boolean {
  const elements = props.historyElements
    .filter(el => !DateUtils.isToday(el.createdDate))
    .filter(el => !DateUtils.isYesterday(el.createdDate))
    .filter(el => !DateUtils.isDayBeforeYesterday(el.createdDate));
  return isEqual(historyElement, findFirst(elements, DateUtils.isThisWeek));
}

function isThisMonth(historyElement: HistoryElement<any>): boolean {
  const elements = props.historyElements
    .filter(el => !DateUtils.isThisWeek(el.createdDate));
  return isEqual(historyElement, findFirst(elements, DateUtils.isThisMonth));
}

function isThisYear(historyElement: HistoryElement<any>): boolean {
  const elements = props.historyElements
    .filter(el => !DateUtils.isThisMonth(el.createdDate));
  return isEqual(historyElement, findFirst(elements, DateUtils.isThisYear));
}

function isOlderThanYear(historyElement: HistoryElement<any>): boolean {
  const elements = props.historyElements
    .filter(el => !DateUtils.isThisYear(el.createdDate));
  return isEqual(historyElement, findFirst(elements, DateUtils.isOlderThanThisYear));
}

const historyList = computed<HistoryElement<any>[]>(() => {
  let list: HistoryElement<any>[] = props.historyElements;
  if (props.last) {
    list = list.slice(0, props.last);
  }

  if (!props.chat) {
    return list;
  }

  return chain<HistoryElement<any>>(list).filter(historyElement => historyElement.type === FpMessageType.NOTE_ADDED)
    .uniq()
    .value();
});

function addNote(): void {
  if (newNote.value.length) {
    emit('click:new-note', newNote.value, props.dealId ? props.dealId : props.loanApplicationId);
    newNote.value = '';
  } else {
    $snackbarService.openWarningSnackbar(I18NGetter().useHistoryElements.WARNING_SNACKBAR_ADD_NOTE);
  }
}

return { __sfc: true,$snackbarService, props, emit, newNote, findFirst, isToday, isYesterday, isDayBeforeYesterday, isThisWeek, isThisMonth, isThisYear, isOlderThanYear, historyList, addNote, FpMessage, I18NGetter }
}

})